module.exports = __webpack_public_path__ + "static/scale-model-of-watermelon-house-in-alexandria-virginia-316397c7fa0d1675194cead4a9a6fee6.png";